import api from './api';

// Fetch all items with optional filters
export const fetchItems = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  if (params.search) queryParams.append('search', params.search);
  if (params.is_active !== undefined) queryParams.append('is_active', params.is_active);
  if (params.category_id) queryParams.append('category_id', params.category_id);
  
  const url = `/admin/items/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const response = await api.get(url);
  return response.data;
};

// Fetch single item by ID
export const fetchItemById = async (id) => {
  const response = await api.get(`/admin/items/${id}/`);
  return response.data;
};

// Fetch and add item from 1688
export const fetchAndAddItem = async (data) => {
  const response = await api.post('/admin/items/fetch-and-add/', data);
  return response.data;
};

// Create local supplier item
export const addLocalSupplierItem = async (data) => {
  const response = await api.post('/admin/items/add-local-supplier-item/', data);
  return response.data;
};

// Update item
export const updateItem = async (id, data) => {
  const response = await api.put(`/admin/items/${id}/`, data);
  return response.data;
};

// Delete item
export const deleteItem = async (id) => {
  const response = await api.delete(`/admin/items/${id}/`);
  return response.data;
};

// Toggle item active status
export const toggleItemActive = async (id) => {
  const response = await api.post(`/admin/items/${id}/toggle-active/`);
  return response.data;
};

// Category APIs
export const fetchCategories = async (params = {}) => {
  const queryParams = new URLSearchParams();

  // Optional basic search
  if (params.search) queryParams.append('search', params.search);

  // If caller requests "all" categories, ask backend for a large page_size so all fit in one response.
  // This is safe for small lists (tens/hundreds) and avoids client-side pagination for dropdowns.
  if (params.fetchAll) {
    queryParams.append('page', '1');
    queryParams.append('page_size', params.page_size ? String(params.page_size) : '1000');
  } else {
    if (params.page) queryParams.append('page', String(params.page));
    if (params.page_size) queryParams.append('page_size', String(params.page_size));
  }

  const url = `/admin/categories/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const response = await api.get(url);
  const data = response.data;

  // Normalize to a plain array for consumers
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data.results)) {
    return data.results;
  }
  return [];
};

export const createCategory = async (data) => {
  const response = await api.post('/admin/categories/', data);
  return response.data;
};

export const bulkCreateCategories = async (names) => {
  const response = await api.post('/admin/categories/bulk-create/', { names });
  return response.data;
};

export const updateCategory = async (id, data) => {
  const response = await api.put(`/admin/categories/${id}/`, data);
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await api.delete(`/admin/categories/${id}/`);
  return response.data;
};

const itemService = {
  fetchItems,
  fetchItemById,
  fetchAndAddItem,
  addLocalSupplierItem,
  updateItem,
  deleteItem,
  toggleItemActive,
  fetchCategories,
  createCategory,
  bulkCreateCategories,
  updateCategory,
  deleteCategory
};

export default itemService;
